module.exports = __webpack_public_path__ + "static/img/progress_type1.7274f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_type1.png
// module id = iGsL
// module chunks = 1